export default "__VITE_ASSET__CkO6Qvat__"